import { BASE_API_URL } from "../../../constants";
import fpFetch from "../../../services/fpFetch";

const createDocumentClone = async (id, launch, instantiateTemplate) => {
  try {
    window.openFpToast("Generating clone...", "info");

    if (!id) throw new Error("No id provided");
    const response = await fpFetch(`${BASE_API_URL}/workspaces/clone`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        _id: id,
        instantiateTemplate: instantiateTemplate,
      }),
    });
    if (response?.ok) {
      const data = await response.json();
      if (data && data.workspaceId && launch) {
        const { type } = data || {};
        const typeToBaseUrl = {
          querygrid: "/matrix",
          private_doc_editor: "/reports",
          private_doc_editor_template: "/report-templates",
        };
        const appBaseUrl = type ? typeToBaseUrl[type] : undefined;

        if (!appBaseUrl) {
          window.openFpToast(
            "Error occurred while generating clone: unknown workspace type",
            "error"
          );
          return null;
        }

        window.openFpToast("Redirecting...", "success");
        window.location.href = `${appBaseUrl}/${data.workspaceId}`;
      }
      return data?.workspaceId;
    } else {
      throw new Error("Cloning api response is not ok");
    }
  } catch (error) {
    window.openFpToast("Error occurred while generating clone", "error");
    console.error(error);
  }
};

export default createDocumentClone;
